function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  outline: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Svg from './Svg';
import styled from 'styled-components';

var BaseComponent = function BaseComponent(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = _objectWithoutProperties(_ref, ["size", "title", "desc", "titleId", "descId"]);

  var ariaLabelledBy = titleId ? titleId : '';
  ariaLabelledBy += desc && descId ? " ".concat(descId) : '';
  ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
  props['aria-labelledby'] = ariaLabelledBy;
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    title: title,
    titleId: titleId,
    desc: desc,
    descId: descId,
    "aria-labelledby": ariaLabelledBy,
    "aria-hidden": !ariaLabelledBy,
    fill: "currentcolor"
  }, props), !!title && /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title), !!desc && /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc), /*#__PURE__*/React.createElement("path", {
    d: "M21.237 11.713h2.262v1.747h-2.262v2.268H19.49V13.46h-2.27v-1.747h2.27V9.445h1.747v2.268zm-10.87-7.412a1.601 1.601 0 11-3.202 0 1.601 1.601 0 013.203 0zM5.252 5.904a1.356 1.356 0 11-2.71 0 1.356 1.356 0 012.71 0zm-.555 6.467v.058l1.355 1.356-.617.616v5.548c0 .555-.431 1.047-.986 1.047H3.28c-.555 0-.986-.492-.986-1.047v-5.543L1 13.112V9.354c0-.801.74-1.54 1.54-1.54h2.218c-.062.06-.062.184-.062.307v4.25zM14.93 5.904a1.356 1.356 0 11-2.71 0 1.356 1.356 0 012.71 0zm.125 1.908c1.477 0 1.477 1.541 1.477 1.541v3.696l-1.353 1.354v5.543c0 .555-.432 1.047-.986 1.047h-1.17c-.495 0-.987-.492-.987-1.047v-5.543l-.677-.677 1.356-1.356V8.12v-.308h2.34zM10.37 6.581c1.48 0 1.478 1.54 1.476 1.54v4.128l-1.478 1.478v6.221c0 .616-.308 1.293-.924 1.293H8.15c-.554 0-1.17-.677-1.17-1.293V13.85v-.123l-.123-.123L5.44 12.25V8.12c0-.124.307-1.54 1.847-1.54h3.082z"
  }));
};

var SvgMultiOccupancy = styled(BaseComponent)(_templateObject());
SvgMultiOccupancy.isIcon = true;
SvgMultiOccupancy.defaultProps = {
  size: 24,
  tabIndex: -1,
  focusable: false,
  'aria-hidden': true,
  role: 'img'
};
export default SvgMultiOccupancy;